import L from "leaflet";

/**
 * Deslizador de opacidad del relleno de los lotes (0–100 %) para la barra superior del mapa
 * (pedido del usuario, 2026-10-07). Hoy lo usa solo el mapa de ganadería. No guarda nada: el valor
 * inicial lo pasa quien lo monta, y cada cambio se avisa con `onCambio` (opacidad de 0 a 1).
 */
export class OpacidadControl {
  private _contenedor: HTMLDivElement | null = null;
  private _input: HTMLInputElement | null = null;
  private _onInput: (() => void) | null = null;

  /** Crea el control dentro de `parent` (la barra superior) con el valor inicial (de 0 a 1). */
  init(
    parent: HTMLElement,
    valorInicial: number,
    onCambio: (opacidad: number) => void,
  ): void {
    const contenedor = L.DomUtil.create("div", "sx-map-opacidad", parent) as HTMLDivElement;
    contenedor.title = "Opacidad del relleno";
    contenedor.innerHTML = `
      <i class="ph ph-drop-half" aria-hidden="true"></i>
      <input type="range" min="0" max="100" step="5" aria-label="Opacidad del relleno" />
      <span class="sx-map-opacidad-valor"></span>`;

    const input = contenedor.querySelector<HTMLInputElement>("input")!;
    const valor = contenedor.querySelector<HTMLSpanElement>(".sx-map-opacidad-valor")!;
    input.value = String(Math.round(valorInicial * 100));
    valor.textContent = `${input.value}%`;

    // Arrastrar el deslizador no debe mover ni hacer zoom en el mapa.
    L.DomEvent.disableClickPropagation(contenedor);
    L.DomEvent.disableScrollPropagation(contenedor);

    this._onInput = () => {
      valor.textContent = `${input.value}%`;
      onCambio(Number(input.value) / 100);
    };
    input.addEventListener("input", this._onInput);

    this._contenedor = contenedor;
    this._input = input;
  }

  /** Quita el listener y el control de la barra. */
  dispose(): void {
    if (this._input && this._onInput) {
      this._input.removeEventListener("input", this._onInput);
    }
    this._contenedor?.remove();
    this._contenedor = null;
    this._input = null;
    this._onInput = null;
  }
}
